import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { addCustomNotification } from 'api/auth.api';
import { addGeneralInformation } from 'api/auth.api';
import { addBook } from 'api/auth.api';

export const useAddBook = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addBook,

    onSuccess: (res) => {
      toast({
        title: 'Book Uploaded',
        description: res?.data?.message || 'Uploaded successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to upload book',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
